const routes = [
    {
        path: "/virtual/pos",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "virtualpos_index",
        }
    }
];

export default routes;
